import { useState, useEffect, useCallback } from 'react';
import { getMatches } from './utils';
import {
  mobileLayoutMediaQuery,
  desktopLayoutMediaQuery,
  tabletLayoutMediaQuery,
  modulorMobileMediaQuery,
  betbookMobileMediaQuery,
  smallMobileLayoutMediaQuery,
  betbookLayoutMediaQuery,
} from '../../constants/responstive';

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => getMatches(query));

  const handleChange = useCallback(() => {
    setMatches(getMatches(query));
  }, [query]);

  useEffect(() => {
    const matchMedia = window.matchMedia(query);

    // Triggered at the first client-side load and if query changes
    handleChange();

    // Listen matchMedia
    if (matchMedia?.addListener) {
      matchMedia?.addListener(handleChange);
    } else {
      matchMedia?.addEventListener('change', handleChange);
    }

    return () => {
      if (matchMedia?.removeListener) {
        matchMedia?.removeListener(handleChange);
      } else {
        matchMedia?.removeEventListener('change', handleChange);
      }
    };
  }, [query, handleChange]);

  return matches;
};

export const useIsMobileLayout = () => {
  return useMediaQuery(mobileLayoutMediaQuery);
};

export const useIsDesktopLayout = () => {
  return useMediaQuery(desktopLayoutMediaQuery);
};

export const useIsBetbookDesktopLayout = () => {
  return useMediaQuery(betbookLayoutMediaQuery);
};

export const useIsTabletLayout = () => {
  return useMediaQuery(tabletLayoutMediaQuery);
};

export const useIsModulorMobileLayout = () => {
  return useMediaQuery(modulorMobileMediaQuery);
};
export const useIsBetbookMobileLayout = () => {
  return useMediaQuery(betbookMobileMediaQuery);
};

export const useIsSmallMobileLayout = () => {
  return useMediaQuery(smallMobileLayoutMediaQuery);
};
